<template>
  <div class="image-preview-container m-auto">
    <div class="image-preview-header">
      Attachment Image
    </div>
    <div class="image-preview-body">
      <div class="image-preview-overall-list pt-1">
        <span>{{ currentPage }}/{{ imageList.length }}</span>
      </div>
      <div class="image-preview-show-image">
        <div
        @click="showFullscreen"
          class="image-preview-content"
          :style="{
            backgroundImage: 'url(' + renderImage + ')',
            transform: 'rotate(' + rotateImage + 'deg)',
          }"
        ></div>
      </div>
      <div class="image-preview-zoom-image">
        <icon-zoom-img @click.native="showFullscreen" />
      </div>
    </div>
    <div class="image-preview-footer">
      <div class="image-preview-rotate">
        <icon-rotate-left @click.native="onRotateImage('left')" />
        <icon-rotate-right @click.native="onRotateImage('right')" />
      </div>
      <div class="image-preview-pagination d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="imageList.length"
          :per-page="1"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0 pagination-with-reorder"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
    <image-preview-fullscreen
      :imageUrl="renderImage"
      :rotate="rotateImage"
      :bindValue="showFullscreenImage.show"
      @closeModal="hideFullscreen"
    />
  </div>
</template>

<script>
import { computed, reactive, ref } from "@vue/composition-api";
import IconZoomImg from "@/@core/components/svg/common/IconZoomImg.vue";
import IconRotateLeft from "@/@core/components/svg/document-service/IconRotateLeft.vue";
import IconRotateRight from "@/@core/components/svg/document-service/IconRotateRight.vue";
import ImagePreviewFullscreen from "./ImagePreviewFullscreen.vue";
import useModal from '@/@core/components/base-modal/hooks/useModal';
export default {
  components: {
    IconZoomImg,
    IconRotateRight,
    IconRotateLeft,
    ImagePreviewFullscreen,
  },
  props: { imageList: { type: Array, default: [] } },
  setup(props) {
    const {openModal , closeModal} = useModal();
    const showFullscreenImage = reactive({
      show: false,
    });
    const currentPage = ref(1);
    const rotateList = ref([]);
    const renderImage = computed(() => {
      return props.imageList[currentPage.value - 1]?.imageUrl;
    });

    const rotateImage = computed(() => {
      if (rotateList.value.length == 0) {
        rotateList.value = [...props.imageList];
      }
      return rotateList.value[currentPage.value - 1]?.rotate;
    });

    const onRotateImage = (side) => {
      if (side == "left") {
        rotateList.value[currentPage.value - 1].rotate -= 90;
      } else {
        rotateList.value[currentPage.value - 1].rotate += 90;
      }
    };

    const showFullscreen = () => {
      showFullscreenImage.show = true;
      openModal();
    };

    const hideFullscreen = () => {
      showFullscreenImage.show = false;
      closeModal();
    };

    return {
      showFullscreenImage,
      currentPage,
      renderImage,
      rotateImage,
      onRotateImage,
      showFullscreen,
      hideFullscreen,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/image-preview-list.css";
@import "~@/assets/css/override-styles/pagination-with-reorder.css";
</style>
